<div *ngIf="filteredAssets$ | async as assets" id="wrapper" [style.height]="assets.length === 0 ? 'calc(100% - 98px)' : 'auto'">
  <div class="container">
    <mat-form-field appearance="fill" appearance="outline" class="search-form-field" color="accent">
      <mat-label>Search by name or id</mat-label>
      <input (input)="onSearch()" [(ngModel)]="searchText" matInput>
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <button (click)="onCreate($event)" color="accent" mat-flat-button>
      <mat-icon>add_circle</mat-icon>
      Create asset
    </button>
  </div>

  <div *ngIf="assets.length === 0" class="empty-wrapper">
    <div class="no-assets-message">
      <mat-icon style="font-size: 64px; width: 64px; height: 64px;">inbox</mat-icon>
      <h2>No assets available</h2>
      <p>The connector doesn't have any assets.</p>
      <p>Create a new asset to get started.</p>
    </div>
  </div>

  <div class="cards-grid" *ngIf="assets.length > 0">
    <mat-card *ngFor="let asset of assets" class="asset-card">
      <mat-card-header>
        <mat-icon mat-card-avatar>inbox</mat-icon>
        <mat-card-title>{{asset.properties.optionalValue('edc','name')}}</mat-card-title>
      </mat-card-header>
      <mat-divider class="asset-header-divider"></mat-divider>
      <mat-card-content>
        <div class="asset-properties">
          <div class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>info</mat-icon>
              <div class="asset-property-header">Id</div>
            </div>
            <div class="asset-property-value">{{asset.properties.optionalValue('edc','id')}}</div>
          </div>

          <div class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>category</mat-icon>
              <div class="asset-property-header">Content Type</div>
            </div>
            <div class="asset-property-value">{{asset.properties.optionalValue('edc','contenttype')}}</div>
          </div>

          <div class="asset-property-row">
            <div class="asset-property-top">
              <mat-icon>file_copy</mat-icon>
              <div class="asset-property-header">Version</div>
            </div>
            <div class="asset-property-value">{{asset.properties.optionalValue('edc','version')}}</div>
          </div>
        </div>

        <mat-expansion-panel *ngIf="getDataAddress(asset) as dataAddress">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Data Address
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="asset-properties">
            <div class="asset-property-row" *ngIf="getDataAddressType(dataAddress)">
              <div class="asset-property-top">
                <mat-icon class="asset-panel-icon">badge</mat-icon>
                <div class="asset-property-header">Type</div>
              </div>
              <div class="asset-property-value">{{getDataAddressType(dataAddress)}}</div>
            </div>

            <div class="asset-property-row" *ngIf="getDataAddressField(dataAddress, 'name')">
              <div class="asset-property-top">
                <mat-icon class="asset-panel-icon">label</mat-icon>
                <div class="asset-property-header">Name</div>
              </div>
              <div class="asset-property-value">{{getDataAddressField(dataAddress, 'name')}}</div>
            </div>

            <div class="asset-property-row" *ngIf="getDataAddressField(dataAddress, 'baseUrl')">
              <div class="asset-property-top">
                <mat-icon class="asset-panel-icon">link</mat-icon>
                <div class="asset-property-header">Base URL</div>
              </div>
              <div class="asset-property-value">{{getDataAddressField(dataAddress, 'baseUrl')}}</div>
            </div>

            <div class="asset-property-row" *ngIf="getDataAddressField(dataAddress, 'proxyPath') !== undefined">
              <div class="asset-property-top">
                <mat-icon class="asset-panel-icon">route</mat-icon>
                <div class="asset-property-header">Proxy Path</div>
              </div>
              <div class="asset-property-value">{{getDataAddressField(dataAddress, 'proxyPath')}}</div>
            </div>

            <div class="asset-property-row" *ngIf="getDataAddressField(dataAddress, 'proxyQueryParams') !== undefined">
              <div class="asset-property-top">
                <mat-icon class="asset-panel-icon">filter_alt</mat-icon>
                <div class="asset-property-header">Proxy Query Params</div>
              </div>
              <div class="asset-property-value">{{getDataAddressField(dataAddress, 'proxyQueryParams')}}</div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-card-content>

      <mat-card-footer class="asset-card-footer">
        <button
          (click)="onDelete(asset)"
          [disabled]="isBusy()"
          color="warn"
          class="card-footer-button"
          mat-stroked-button>
          <mat-icon>delete</mat-icon> Delete
        </button>
        <mat-progress-bar *ngIf="isBusy()" color="accent" mode="indeterminate"></mat-progress-bar>
      </mat-card-footer>
    </mat-card>
  </div>

  <mat-paginator *ngIf="assets.length" [length]="assets.length" hidePageSize="true" pageSize="contractDefinitions.length">
  </mat-paginator>

</div>
